<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="right-side-bar-main-sec deposit_section deposit_module_wrappe">
            <div class="deposit-withdraw-sec">
                <div class="go-to-back-sec wallet_back_btn">
                    <a @click="$router.go(-1)">
                        {{ $t('back', 'Back') }}
                    </a>
                </div>
                <div class="dw_bg_cl">
                    <div class="depo-rgt-container amount_container_cl">
                        <div class="amount_input_cl">
                            <label for="amount1">{{ $t('deposit-amount', 'Deposit Amount') }} <span>*</span></label>
                            <div class="amount_input_btn_cl">
                                <input type="number" :placeholder="$t('enter-amt', 'Enter Amount')" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)" v-model="amount" class="form-control">
                                <button type="button" :class="{'btn-disabled' : amount < walletConfig?.deposit_range?.min }" class="submit_btn_cl" @click="callForDepositMethods()">
                                    {{ $t('submit', 'SUBMIT') }}
                                </button>
                            </div>
                            <div class="wallet-minmax">{{ $t('min', 'Min') }}: {{ walletConfig?.deposit_range?.min ?? 100 }} | {{ $t('max', 'Max') }}: {{ walletConfig?.deposit_range?.max ?? 99999999 }}</div>
                            <div class="amount-select-box"  v-if="walletData">
                                <div class="amount-sub-box" v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes].splice(0, 4) : walletConfig?.stake_button)" :key="index">
                                    <button @click="setAmount(stake)"  type="button">+{{ stake }}</button>
                                </div>
                            </div>
                            <div class="submit-btn select_amount_btn">
                                <a href="#walleteditstackModal" data-bs-toggle="modal" class="thm-but">
                                    <img loading="lazy" src="@/assets/images/edit-icon.svg" alt="">
                                     {{$t('edit-stake','Edit Stake')}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <WalletInstructions instructionType="deposit" />
                    <div class="deposit-main-body">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="depo-rgt-container deposit_amount_table_cl">
                                    <div class="withdrawal_rgt_container">
                                        <div class="table-responsive">
                                            <WalletHistory :filterType="2"></WalletHistory>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <WalletStakeModal ref="resetStakeCall" v-if="walletData" :stakes="walletData" />
    <WalletInstructionVideos langKey="Deposit"/>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import {  setWalletStakeValue } from '../services/module';
import WalletInstructions from '../components/WalletInstructions.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
import WalletStakeModal from '../components/WalletStakeModal.vue';
import WalletHistory from '../components/WalletHistory.vue';
export default {
    name: 'WalletDeposit',
    inject: ['walletConfig'],
    components: { 
        WalletHistory,
        WalletStakeModal,
        WalletInstructionVideos,
        WalletInstructions,
    },
    computed:{
        minAmount() {
            return this.walletConfig?.deposit_range?.min ?? 100;
        },
        maxAmount() {
            return this.walletConfig?.deposit_range?.max ?? 99999999;
        },
        ...mapGetters(['userTransactionStakes'])
    },
    data() {
        return {
            walletData: null,
            amount: null
        }
    },
    mounted() {
        this.getStakes();
    },
    methods: {
        setAmount(stake){
            try {
                const response =  setWalletStakeValue(stake, this.amount, this.walletConfig)
                if(response){
                    this.amount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        callForDepositMethods() {
            if (this.amount == null || this.amount < this.minAmount || this.amount > this.maxAmount) {
                this.$errorToast(`${this.$t('please-enter-an-amount-between', 'Please enter an amount between')} ${this.minAmount} and ${this.maxAmount}.`);
            } else {
                this.goToDepositMethods();
            }
        },
        getStakes() {
            this.walletData = this.walletConfig?.stake_button;
            if(!this.walletData) {
                this.initializeStake();
            } 
        },
        initializeStake(){
            this.walletData.stake = {
                stake1 : 100,
                stake2 : 500,
                stake3 : 1000,
                stake4 : 2000,
            };
        },
        goToDepositMethods() {
            this.$store.dispatch('setDepositAmount', this.amount);
            this.$router.push({ name: 'deposit-payment-method' })
        }
    }
}
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>